import React from "react";
import { Text as UI5Text, Title } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Text({ className, children, ...props }) {
  return (
    <UI5Text className={cn(className)} {...props}>
      {children}
    </UI5Text>
  );
}

Text.Title = function TextTitle({
  className,
  level = "H2",
  wrappingType = "None",
  children,
  ...props
}) {
  return (
    <Title
      level={level}
      wrappingType={wrappingType}
      className={cn(className)}
      {...props}
    >
      {children}
    </Title>
  );
};
